import React, { Component } from "react";

import ImageComparison from "../libraries/ImageComparison";
import "./CatalogSpecimenPreview.css";

const intersperse = <T>(x: T, a: T[]): T[] =>
  [].concat(...a.map(e => [x, e])).slice(1);

class CatalogSpecimenPreview extends Component {
  constructor(props) {
    super(props);

    this.container = null;
    this.containerFn = ref => {
      this.container = ref;
    };

    this.ref1 = null;
    this.ref1Fn = ref => {
      this.ref1 = ref;
    };

    this.ref2 = null;
    this.ref2Fn = ref => {
      this.ref2 = ref;
    };
  }
  componentDidMount() {
    new ImageComparison({
      container: this.container,
      startPosition: 50,
      data: [{ image: this.ref1 }, { image: this.ref2 }]
    });
  }
  render() {
    const { source, children } = this.props;
    return (
      <div ref={this.containerFn} className="catalog-specimen-preview">
        <div className="comparison-image source" ref={this.ref1Fn}>
          <div className="gutter">
            {source.map((_, i) => (
              <div key={i} className="line-numeber">{i + 1}</div>
            ))}
          </div>
          {React.createElement(
            "pre",
            {},
            ...[].concat(...intersperse("\n", source))
          )}
        </div>
        <div className="comparison-image example" ref={this.ref2Fn}>
          {children}
        </div>
      </div>
    );
  }
}

export default CatalogSpecimenPreview;

const tokenComponent = token => ({ children }) => (
  <span className={`catalog-specimen-preview-token__${token}`}>{children}</span>
);

export const DarkToken = tokenComponent("dark");
export const LightToken = tokenComponent("light");
export const HighlightToken = tokenComponent("highlight");



// WEBPACK FOOTER //
// ./src/components/CatalogSpecimenPreview.js